// =========================
// HELPERS
// =========================

export const calcularEdad = (
  fechaNacimiento
) => {

  if (!fechaNacimiento)
    return null;

  const hoy = new Date();

  const nacimiento =
    new Date(fechaNacimiento);

  let edad =
    hoy.getFullYear() -
    nacimiento.getFullYear();

  const m =
    hoy.getMonth() -
    nacimiento.getMonth();

  if (
    m < 0 ||
    (
      m === 0 &&
      hoy.getDate() <
      nacimiento.getDate()
    )
  ) {

    edad--;
  }

  return edad;
};

// =========================
// RIESGO PERIODONTAL
// =========================

export const evaluarRiesgoPeriodontal = ({
  paciente,
  historiaClinica,
  periodonto
}) => {

  let score = 0;

  let factores = [];

  // =========================
  // EDAD
  // =========================

  const edad =
    calcularEdad(
      paciente?.fechaNacimiento
    );

  if (edad >= 45) {

    score += 1;

    factores.push(
      "Edad ≥ 45 años"
    );
  }

  // =========================
  // DIABETES
  // =========================

  if (
    historiaClinica
      ?.antecedentesMedicos
      ?.diabetes
  ) {

    score += 3;

    factores.push(
      "Diabetes"
    );
  }

  // =========================
  // TABAQUISMO
  // =========================

  if (
    historiaClinica
      ?.habitos
      ?.tabaquismo
  ) {

    score += 3;

    factores.push(
      "Tabaquismo"
    );
  }

  // =========================
  // BRUXISMO
  // =========================

  if (
    historiaClinica
      ?.habitos
      ?.bruxismo
  ) {

    score += 1;

    factores.push(
      "Bruxismo"
    );
  }

  // =========================
  // HIGIENE
  // =========================

  const cepillados =
    Number(

      historiaClinica
        ?.higiene
        ?.cepilladosDia

    ) || 0;

  if (cepillados <= 1) {

    score += 2;

    factores.push(
      "Higiene deficiente"
    );
  }

  // =========================
  // PERIODONTO
  // =========================

  const datos =
    periodonto?.datos || {};

  const profundidades =
    Object.values(datos)

      .map(v => Number(v))

      .filter(v => v > 0);

  if (profundidades.length) {

    const max =
      Math.max(...profundidades);

    const promedio =

      profundidades.reduce(
        (a,b)=>a+b,
        0
      ) / profundidades.length;

    if (max >= 6) {

      score += 4;

      factores.push(
        "Bolsas ≥ 6mm"
      );
    }

    if (promedio >= 4) {

      score += 3;

      factores.push(
        "Promedio periodontal elevado"
      );
    }
  }

  // =========================
  // CLASIFICACIÓN
  // =========================

  let riesgo =
    "Bajo";

  let color =
    "#22c55e";

  if (score >= 5) {

    riesgo =
      "Moderado";

    color =
      "#f59e0b";
  }

  if (score >= 9) {

    riesgo =
      "Alto";

    color =
      "#ef4444";
  }

  return {

    riesgo,

    color,

    score,

    factores
  };
};

// =========================
// ALERTAS MÉDICAS
// =========================

export const generarAlertasMedicas = ({
  historiaClinica
}) => {

  const alertas = [];

  const med =
    historiaClinica
      ?.antecedentesMedicos;

  if (med?.diabetes) {

    alertas.push({

      tipo: "warning",

      titulo:
        "Paciente diabético",

      descripcion:
        "Monitorear cicatrización y control periodontal."
    });
  }

  if (med?.hipertension) {

    alertas.push({

      tipo: "warning",

      titulo:
        "Hipertensión",

      descripcion:
        "Verificar presión arterial antes de procedimientos."
    });
  }

  if (med?.cardiopatias) {

    alertas.push({

      tipo: "danger",

      titulo:
        "Cardiopatía",

      descripcion:
        "Evaluar profilaxis antibiótica si está indicada."
    });
  }

  return alertas;
};

// =========================
// DX PERIODONTAL
// =========================

export const clasificarPeriodonto = ({
  periodonto
}) => {

  const datos =
    periodonto?.datos || {};

  const valores =
    Object.values(datos)

      .map(v => Number(v))

      .filter(v => v > 0);

  if (!valores.length) {

    return {
      dx:
        "Sin datos"
    };
  }

  const max =
    Math.max(...valores);

  const promedio =

    valores.reduce(
      (a,b)=>a+b,
      0
    ) / valores.length;

  if (max <= 3) {

    return {

      dx:
        "Salud periodontal / Gingivitis",

      severidad:
        "leve"
    };
  }

  if (max <= 5) {

    return {

      dx:
        "Periodontitis moderada",

      severidad:
        "moderada"
    };
  }

  return {

    dx:
      "Periodontitis avanzada",

    severidad:
      "severa"
  };
};